// extracted by mini-css-extract-plugin
module.exports = {"progressImport":"styles_progressImport__2WzDU","body":"styles_body__1BuU5","image":"styles_image__1cOM0","button":"styles_button__3GXNv","disabled":"styles_disabled__1dXgC"};